<template>
  <div class="information-page">
    <!-- 顶部导航栏 -->
    <header class="information-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">个人信息</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 基础信息 -->
      <div class="info-section">
        <div class="section-title">基础信息</div>
        <div class="info-list">
          <div class="li" @click="userShow()">
      <div class="name"><span class="required">*</span>用户名</div>
      <div class="value" v-if="uesr">
        {{ uesr }} <i class="el-icon-arrow-right"></i>
      </div>
      <div class="value" v-else>
        请输入用户名 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
          <div class="li" @click="genderShow()">
            <div class="name"><span class="required">*</span>性别</div>
            <div class="value">{{ gender }} <i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="timeClick()">
            <div class="name"><span class="required">*</span>出生日期</div>
            <div v-if="birthday == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div v-else class="value">{{ birthday }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="IDNumberShow()">
            <div class="name"><span class="required">*</span>证件号</div>
            <div class="value" v-if="IDNumber">
              {{ maskIdCard(IDNumber) }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else>
              请输入证件号 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 健康信息 -->
      <div class="info-section">
        <div class="section-title">健康信息</div>
        <div class="info-list">
          <div class="li" @click="showPicker = true">
            <div class="name"><span class="required">*</span>身高</div>
            <div v-if="height == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div class="value" v-else>{{ height }}<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="li" @click="showPicker1 = true">
            <div class="name"><span class="required">*</span>体重</div>
            <div v-if="weight == ''" class="value" style="color:#C0C0C0">请选择<i class="el-icon-arrow-right"></i></div>
            <div class="value" v-else>{{ weight }} <i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="info-section">
        <div class="section-title">其他信息</div>
        <div class="info-list">
          <div class="li" @click="homeAddressShow()">
            <div class="name">家庭地址</div>
            <div class="value" v-if="userDetailAddress">
              {{ userDetailAddress }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else style="color:#C0C0C0">
              请选择 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="li" @click="communityPhoneShow()">
            <div class="name">社区电话</div>
            <div class="value" v-if="communityPhone">
              {{ communityPhone }} <i class="el-icon-arrow-right"></i>
            </div>
            <div class="value" v-else style="color:#C0C0C0">
              请选择 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-button-container">
        <div class="save-button" @click="edit()">
          <img src="@/assets/personalInformation/SaveBackground.png" alt="保存背景" class="save-bg-img" />
          <span class="save-text">保存个人信息</span>
        </div>
      </div>
    </div>

    <van-dialog v-model="cover" :title="getDialogTitle()" show-cancel-button @confirm="qdClikc" :lazy-render="false">
      <div style="padding: 0px 20px 20px 20px; width: 100%; margin: 0 auto">
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 1"
          >
            <el-input v-model="userInput"  @focus="focusEvent($event)" placeholder="请输入用户名"></el-input>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(1)">
              男
              <i class="el-icon-success" v-if="genderInput == '男'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(2)">
              女
              <i class="el-icon-success" v-if="genderInput == '女'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 3"
          >
            <el-input
              v-model="IDNumberInput"
              @focus="focusEvent($event)"
              placeholder="请输入证件号"
            ></el-input>
            <div class="ts" v-if="ts">请输入正确的身份证号码！</div>
            <div ></div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 4"
          >
            <div style="color: #666; font-size: 14px; margin-bottom: 10px; text-align: center;">
              请添加详细地址，便于我们提供精准服务
            </div>
            <el-input
              v-model="homeAddressInput"
              @focus="focusEvent($event)"
              placeholder="请输入详细地址"
            ></el-input>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 5"
          >
            <div style="color: #666; font-size: 14px; margin-bottom: 10px; text-align: center;">
              请添加社区电话，这样如果一键救援暂时联系不上您，我们也能通过社区电话联系到您~
            </div>
            <el-input
              v-model="communityPhoneInput"
              @focus="focusEvent($event)"
              placeholder="请输入社区电话"
            ></el-input>
          </div>
        </div>
      </van-dialog>
    <!-- <div v-show="cover" class="Popupclass" id="btm-keyboard-div">
      <div class="close" >
        <div style="padding: 3vw; text-align: left">
        </div>
        <div style="margin-bottom: 25px">
          <div
            style="
              font-size: 17px;
              text-align: center;
              color: #000000;
              font-weight: 500;
            "
          >
            <div class="qx" @click="cover = false">取消</div>
            <span v-if="type == 1">修改用户名</span>
            <span v-else-if="type == 3">修改证件号</span>
            <span v-else-if="type == 2">修改性别</span>
            <div class="qd" @click="qdClikc()">确定</div>
          </div>
        </div>
        <div style="padding: 0px 20px; width: 100%; margin: 0 auto">
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 1"
          >
            <el-input v-model="userInput"  @focus="focusEvent($event)" placeholder="请输入用户名"></el-input>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(1)">
              男
              <i class="el-icon-success" v-if="genderInput == '男'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            class="gender"
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              text-align: justify;
              font-style: normal;
            "
            v-if="type == 2"
          >
            <div @click="Sexselection(2)">
              女
              <i class="el-icon-success" v-if="genderInput == '女'"></i>
              <div class="round" v-else></div>
            </div>
          </div>
          <div
            style="
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              line-height: 21px;
              text-align: justify;
              font-style: normal;
              margin-top: 20px;
            "
            v-if="type == 3"
          >
            <el-input
              v-model="IDNumberInput"
              @focus="focusEvent($event)"
              placeholder="请输入证件号"
            ></el-input>
            <div class="ts" v-if="ts">请输入正确的身份证号码！</div>
            <div ></div>
          </div>
        </div>
      </div>
    </div> -->
    <div id="cover" v-if="cover"></div>
    <picke
      @child-method="parentMethod"
      @child-show="childShow"
      :value="value"
      :birthday="birthday"
    ></picke>
    <div>
      <van-popup v-model:show="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="idTypecolumn"
          @confirm="onConfirm"
          @cancel="cancel"
        />
      </van-popup>
      <van-popup v-model:show="showPicker1" round position="bottom">
        <van-picker
          show-toolbar
          :columns="idTypecolumn1"
          @confirm="onConfirm1"
          @cancel="cancel1"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { health, uphealthinfo2 } from "@/api/activity";
import { evaluateDiseaseMedicationStatus } from '@/utils/healthReportProfileCheck';
export default {
  data() {
    return {
      list:[],
      ts: false,
      IDNumber: "",
      userDetailAddress: "",
      communityPhone: "",
      genderInput: "男",
      userInput: "",
      IDNumberInput: "",
      homeAddressInput: "",
      communityPhoneInput: "",
      uesr: "",
      gender: "男",
      birthday: "",
      height: "",
      weight: "",
      cover: false,
      type: 1,
      value: false,
      idTypecolumn: [
        { text: "150厘米", keyId: "150" },
        { text: "151厘米", keyId: "151" },
        { text: "152厘米", keyId: "152" },
        { text: "153厘米", keyId: "153" },
        { text: "154厘米", keyId: "154" },
        { text: "155厘米", keyId: "155" },
        { text: "156厘米", keyId: "156" },
        { text: "157厘米", keyId: "157" },
        { text: "158厘米", keyId: "158" },
        { text: "159厘米", keyId: "159" },
        { text: "160厘米", keyId: "160" },
        { text: "161厘米", keyId: "161" },
        { text: "162厘米", keyId: "162" },
        { text: "163厘米", keyId: "163" },
        { text: "164厘米", keyId: "164" },
        { text: "165厘米", keyId: "165" },
        { text: "166厘米", keyId: "166" },
        { text: "167厘米", keyId: "167" },
        { text: "168厘米", keyId: "168" },
        { text: "169厘米", keyId: "169" },
        { text: "170厘米", keyId: "170" },
        { text: "171厘米", keyId: "171" },
        { text: "172厘米", keyId: "172" },
        { text: "173厘米", keyId: "173" },
        { text: "174厘米", keyId: "174" },
        { text: "175厘米", keyId: "175" },
        { text: "176厘米", keyId: "176" },
        { text: "177厘米", keyId: "177" },
        { text: "178厘米", keyId: "178" },
        { text: "179厘米", keyId: "179" },
        { text: "180厘米", keyId: "180" },
        { text: "181厘米", keyId: "181" },
        { text: "182厘米", keyId: "182" },
        { text: "183厘米", keyId: "183" },
        { text: "184厘米", keyId: "184" },
        { text: "185厘米", keyId: "185" },
        { text: "186厘米", keyId: "186" },
        { text: "187厘米", keyId: "187" },
        { text: "188厘米", keyId: "188" },
        { text: "189厘米", keyId: "189" },
        { text: "190厘米", keyId: "190" },
        { text: "191厘米", keyId: "191" },
        { text: "192厘米", keyId: "192" },
        { text: "193厘米", keyId: "193" },
        { text: "194厘米", keyId: "194" },
        { text: "195厘米", keyId: "195" },
        { text: "196厘米", keyId: "196" },
        { text: "197厘米", keyId: "197" },
        { text: "198厘米", keyId: "198" },
        { text: "199厘米", keyId: "199" },
        { text: "200厘米", keyId: "200" },
      ],
      showPicker: false,
      idTypecolumn1: [
        { text: "30公斤", keyId: "30" },
        { text: "31公斤", keyId: "31" },
        { text: "32公斤", keyId: "32" },
        { text: "33公斤", keyId: "33" },
        { text: "34公斤", keyId: "34" },
        { text: "35公斤", keyId: "35" },
        { text: "36公斤", keyId: "36" },
        { text: "37公斤", keyId: "37" },
        { text: "38公斤", keyId: "38" },
        { text: "39公斤", keyId: "39" },
        { text: "40公斤", keyId: "40" },
        { text: "41公斤", keyId: "41" },
        { text: "42公斤", keyId: "42" },
        { text: "43公斤", keyId: "43" },
        { text: "44公斤", keyId: "44" },
        { text: "45公斤", keyId: "45" },
        { text: "46公斤", keyId: "46" },
        { text: "47公斤", keyId: "47" },
        { text: "48公斤", keyId: "48" },
        { text: "49公斤", keyId: "49" },
        { text: "50公斤", keyId: "50" },
        { text: "51公斤", keyId: "51" },
        { text: "52公斤", keyId: "52" },
        { text: "53公斤", keyId: "53" },
        { text: "54公斤", keyId: "54" },
        { text: "55公斤", keyId: "55" },
        { text: "56公斤", keyId: "56" },
        { text: "57公斤", keyId: "57" },
        { text: "58公斤", keyId: "58" },
        { text: "59公斤", keyId: "59" },
        { text: "60公斤", keyId: "60" },
        { text: "61公斤", keyId: "61" },
        { text: "62公斤", keyId: "62" },
        { text: "63公斤", keyId: "63" },
        { text: "64公斤", keyId: "64" },
        { text: "65公斤", keyId: "65" },
        { text: "66公斤", keyId: "66" },
        { text: "67公斤", keyId: "67" },
        { text: "68公斤", keyId: "68" },
        { text: "69公斤", keyId: "69" },
        { text: "70公斤", keyId: "70" },
        { text: "71公斤", keyId: "71" },
        { text: "72公斤", keyId: "72" },
        { text: "73公斤", keyId: "73" },
        { text: "74公斤", keyId: "74" },
        { text: "75公斤", keyId: "75" },
        { text: "76公斤", keyId: "76" },
        { text: "77公斤", keyId: "77" },
        { text: "78公斤", keyId: "78" },
        { text: "79公斤", keyId: "79" },
        { text: "80公斤", keyId: "80" },
        { text: "81公斤", keyId: "81" },
        { text: "82公斤", keyId: "82" },
        { text: "83公斤", keyId: "83" },
        { text: "84公斤", keyId: "84" },
        { text: "85公斤", keyId: "85" },
        { text: "86公斤", keyId: "86" },
        { text: "87公斤", keyId: "87" },
        { text: "88公斤", keyId: "88" },
        { text: "89公斤", keyId: "89" },
        { text: "90公斤", keyId: "90" },
        { text: "91公斤", keyId: "91" },
        { text: "92公斤", keyId: "92" },
        { text: "93公斤", keyId: "93" },
        { text: "94公斤", keyId: "94" },
        { text: "95公斤", keyId: "95" },
        { text: "96公斤", keyId: "96" },
        { text: "97公斤", keyId: "97" },
        { text: "98公斤", keyId: "98" },
        { text: "99公斤", keyId: "99" },
        { text: "100公斤", keyId: "100" },
        { text: "101公斤", keyId: "101" },
        { text: "102公斤", keyId: "102" },
        { text: "103公斤", keyId: "103" },
        { text: "104公斤", keyId: "104" },
        { text: "105公斤", keyId: "105" },
        { text: "106公斤", keyId: "106" },
        { text: "107公斤", keyId: "107" },
        { text: "108公斤", keyId: "108" },
        { text: "109公斤", keyId: "109" },
        { text: "110公斤", keyId: "110" },
        { text: "111公斤", keyId: "111" },
        { text: "112公斤", keyId: "112" },
        { text: "113公斤", keyId: "113" },
        { text: "114公斤", keyId: "114" },
        { text: "115公斤", keyId: "115" },
        { text: "116公斤", keyId: "116" },
        { text: "117公斤", keyId: "117" },
        { text: "118公斤", keyId: "118" },
        { text: "119公斤", keyId: "119" },
        { text: "120公斤", keyId: "120" },
        { text: "121公斤", keyId: "121" },
        { text: "112公斤", keyId: "122" },
        { text: "123公斤", keyId: "123" },
        { text: "124公斤", keyId: "124" },
        { text: "125公斤", keyId: "125" },
        { text: "126公斤", keyId: "126" },
        { text: "127公斤", keyId: "127" },
        { text: "128公斤", keyId: "128" },
        { text: "129公斤", keyId: "129" },
        { text: "130公斤", keyId: "130" },
        { text: "131公斤", keyId: "131" },
        { text: "132公斤", keyId: "132" },
        { text: "133公斤", keyId: "133" },
        { text: "134公斤", keyId: "134" },
        { text: "135公斤", keyId: "135" },
        { text: "136公斤", keyId: "136" },
        { text: "137公斤", keyId: "137" },
        { text: "138公斤", keyId: "138" },
        { text: "139公斤", keyId: "139" },
        { text: "140公斤", keyId: "140" },
        { text: "141公斤", keyId: "141" },
        { text: "142公斤", keyId: "142" },
        { text: "143公斤", keyId: "143" },
        { text: "144公斤", keyId: "144" },
        { text: "145公斤", keyId: "145" },
        { text: "146公斤", keyId: "146" },
        { text: "147公斤", keyId: "147" },
        { text: "148公斤", keyId: "148" },
        { text: "149公斤", keyId: "149" },
        { text: "150公斤", keyId: "150" },
      ],
      showPicker1: false,
      userCode: "",
    };
  },
  components: {
    picke: () => import("./picke"),
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  mounted() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    this.getData();
  },
  beforeDestroy() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
  },
  methods: {
    /**
     * 返回：来自健康档案则回档案，否则回上一页
     * @returns {void}
     */
    goBack() {
      const from = this.$route.query.from;
      if (from === 'healthArchive') {
        this.$router.replace({ name: 'healthArchive' }).catch(() => {});
        return;
      }
      this.$router.go(-1);
    },
    focusEvent(e) {
      console.log('focusEvent');
      const ele = e.target;
      const kdv = document.getElementById('btm-keyboard-div');
      if (kdv) {
        kdv.style = 'height: 450px';
      }
      ele.scrollIntoView(true);
    },
    blurEvent() {
      console.log('blurEvent');
      const kdv = document.getElementById('btm-keyboard-div');
      if (kdv) {
        kdv.style = 'height:none';
      }
    },
    getData() {
      health().then((res) => {
        if (res.code == 1000) {
          this.uesr = res.data.name || '';
          this.IDNumber = res.data.idNo || '';
          if (res.data.sex == 2) {
            this.gender = '女';
          } else {
            this.gender = '男';
          }
          if (res.data.birthday == null) {
            this.birthday = '';
          } else {
            this.birthday = this.convertDateString(res.data.birthday) || '';
          }
          if (res.data.height != null) {
            this.height = res.data.height + '厘米' || '';
          }
          if (res.data.weight != null) {
            this.weight = res.data.weight + '公斤' || '';
          }
          if (res.data.userDetailAddress) {
            this.userDetailAddress = res.data.userDetailAddress;
          }
          if (res.data.communityPhone) {
            this.communityPhone = res.data.communityPhone;
          }
        }
      });
      this.userCode = localStorage.getItem('userCode');
    },
    edit() {
      if (this.uesr == '' || this.uesr == null) {
        this.$message.error('用户名为必填项，请输入用户名');
        return;
      }
      if (this.gender == '' || this.gender == null) {
        this.$message.error('性别为必填项，请选择性别');
        return;
      }
      if (this.birthday == '' || this.birthday == null) {
        this.$message.error('出生日期为必填项，请选择出生日期');
        return;
      }
      if (this.height == '' || this.height == null) {
        this.$message.error('身高为必填项，请选择身高');
        return;
      }
      if (this.weight == '' || this.weight == null) {
        this.$message.error('体重为必填项，请选择体重');
        return;
      }
      if (this.IDNumber == '' || this.IDNumber == null) {
        this.$message.error('证件号为必填项，请输入证件号');
        return;
      }
      if (this.gender == '男') {
        this.gender = 1;
      } else {
        this.gender = 2;
      }

      const obj = {
        userCode: this.userCode,
        name: this.uesr,
        idNo: this.IDNumber,
        sex: this.gender,
        birthday: this.formatDate(new Date(this.transferTime(this.birthday))),
        height: parseInt(this.height.slice(0, -2)),
        weight: parseInt(this.weight.slice(0, -2)),
        takeMed: false,
        userDetailAddress: this.userDetailAddress,
        communityPhone: this.communityPhone
      };
      uphealthinfo2(obj).then(async (res) => {
        if (res.code == 1000) {
          await this.handleSaveSuccess();
        }
      });
    },
    /**
     * 保存成功后检查疾病用药是否完善，并决定跳转
     * @returns {Promise<void>}
     */
    async handleSaveSuccess() {
      this.$message({
        type: 'success',
        message: '编辑成功!'
      });

      const { complete } = await evaluateDiseaseMedicationStatus();
      if (!complete) {
        try {
          await this.$confirm(
            '请完善您的疾病用药情况，否则将影响您的健康日报、健康周报生成',
            '友情提示',
            {
              confirmButtonText: '去完善',
              cancelButtonText: '取消',
              type: 'warning',
              closeOnClickModal: false,
              closeOnPressEscape: true
            }
          );
          sessionStorage.setItem('healthArchive_openDiseaseTab', '1');
          this.$router
            .push({
              path: '/healthArchive',
              query: { from: this.$route.query.from || 'information' }
            })
            .catch(() => {});
        } catch (error) {
          this.navigateAfterSave();
        }
        return;
      }

      this.navigateAfterSave();
    },
    /**
     * 保存成功后按来源页面跳转
     * @returns {void}
     */
    navigateAfterSave() {
      const from = this.$route.query.from;
      if (from === 'healthArchive') {
        this.$router.replace({ name: 'healthArchive' }).catch(() => {});
        return;
      }
      if (from === 'healthHomePage') {
        this.$router.push({ path: '/healthHomePage' }).catch(() => {});
        return;
      }
      this.$router.push({ path: '/mine' }).catch(() => {});
    },
    convertDateString(dateString) {
      const dateParts = dateString.split('-');
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];

      return `${year}年${month}月${day}日`;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    transferTime(data) {
      const str = data;
      const regex = /年/g;
      const regex1 = /月/g;
      const newStr = str.replace(regex, '/');
      const newStr2 = newStr.replace(regex1, '/');
      return newStr2.slice(0, -1);
    },
    cancel() {
      this.showPicker = false;
    },
    onConfirm(idType) {
      this.height = idType.text;
      this.showPicker = false;
    },
    cancel1() {
      this.showPicker1 = false;
    },
    onConfirm1(idType) {
      this.weight = idType.text;
      this.showPicker1 = false;
    },
    childShow(msg) {
      this.value = msg;
    },
    parentMethod(msg) {
      this.birthday = msg;
      this.value = false;
    },
    timeClick() {
      this.value = true;
    },
    Sexselection(type) {
      if (type == 1) {
        this.genderInput = '男';
      } else {
        this.genderInput = '女';
      }
    },
    qdClikc() {
      this.value = false;
      if (this.type == 1) {
        this.uesr = this.userInput;
        this.cover = false;
      } else if (this.type == 2) {
        this.cover = false;
        this.gender = this.genderInput;
      } else if (this.type == 3) {
        if (this.isValidID(String(this.IDNumberInput))) {
          this.cover = false;
          this.ts = false;
        } else {
          this.cover = true;
          this.ts = true;
        }
        this.IDNumber = this.IDNumberInput;
      } else if (this.type == 4) {
        this.userDetailAddress = this.homeAddressInput;
        this.cover = false;
      } else if (this.type == 5) {
        this.communityPhone = this.communityPhoneInput;
        this.cover = false;
      }
    },
    maskIdCard(idCard) {
      const firstPart = idCard.slice(0, 6);
      const middlePart = '*'.repeat(8);
      const lastPart = idCard.slice(14);
      return firstPart + middlePart + lastPart;
    },
    isValidID(idNumber) {
      if (
        !/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          idNumber
        )
      ) {
        return false;
      }
      let sum = 0;
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      for (let i = 0; i < 17; i++) {
        sum += idNumber.substring(i, i + 1) * weights[i];
      }
      const mod = sum % 11;
      const lastChar = idNumber.substring(17, 18);
      if (checkCodes[mod] !== lastChar) {
        return false;
      }
      return true;
    },
    genderShow() {
      this.type = 2;
      this.genderInput = this.gender;
      this.cover = true;
    },
    IDNumberShow() {
      this.type = 3;
      this.IDNumberInput = this.IDNumber;
      this.cover = true;
    },
    homeAddressShow() {
      this.type = 4;
      this.homeAddressInput = this.userDetailAddress;
      this.cover = true;
    },
    communityPhoneShow() {
      this.type = 5;
      this.communityPhoneInput = this.communityPhone;
      this.cover = true;
    },
    userShow() {
      this.type = 1;
      this.userInput = this.uesr;
      this.cover = true;
    },
    getDialogTitle() {
      switch (this.type) {
        case 1:
          return '修改用户名';
        case 2:
          return '修改性别';
        case 3:
          return '修改证件号';
        case 4:
          return '添加家庭地址';
        case 5:
          return '添加社区电话';
        default:
          return '请输入信息';
      }
    }
  },
  created() {
   
  }
};
</script>
<style scoped>
.information-page {
  min-height: 100vh;
  background-color: #F7F7F7;
  padding-bottom: 100px;
}

/* 顶部导航栏 */
.information-header {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  
  &:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
}

.nav-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  max-width: calc(100% - 120px);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.nav-placeholder {
  width: 24px;
}

/* 内容区域 */
.content-wrapper {
  background-color: #F7F7F7;
  padding: 16px;
  margin-top: -20px;
  border-radius: 20px 20px 0 0;
  position: relative;
  z-index: 1;
}

/* 信息分组 */
.info-section {
  margin-top: 0;
  margin-bottom: 16px;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-section:first-child {
  margin-top: 0;
}

.section-title {
  padding: 16px 16px 12px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  background-color: #ffffff;
}

.info-list {
  background-color: #ffffff;
  border-radius: 0 0 12px 12px;
}

.jiazu {
  width:300px !important;
  height: 100px !important;
}
#cover {
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  filter: alpha(opacity=100); /*设置透明度为100%*/
  opacity: 1; /*非IE浏览器下设置透明度为100%*/
  display: block;
  z-index: 999;
}
.Popupclass {
  position: fixed;
  bottom: 0vw;
  z-index: 9999;
  height: 200px;
  border-radius: 20px 20px 0px 0px;
}
.Popupclass {
  width: 100%;
  z-index: 9999;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 15vw;
  box-sizing: border-box;
}
.close {
  text-align: right;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #151515;
  height: 60px;
  background: #f9fafb;
  border-radius: 20px 20px 0px 0px;
  /* line-height: 60px; */
  /* margin-bottom: 100px; */
}
.el-input {
  width: 100% !important;
}
.totalBox {
  width: 100%;
  height: 84px;
  background: #ffffff;
  padding: 10px 21px;
}
.defeat {
  width: 100%;
  height: 64px;
  background: #f3f3f3;
  border-radius: 10px;
  /* margin-top: 16px; */
  display: flex;
  /* justify-content: center;  */
  align-items: left;
}
.drop {
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
  margin: 0px 10px;
  position: absolute;
  top: 18px;
  left: 2px;
}
.defeatName {
  height: 64px;
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center;  */
  margin-left: 10px;
  padding-left: 28px;
  position: relative;
}
.li {
  width: 100%;
  min-height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e4ea;
  padding: 0px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.li:last-child {
  border-bottom: none;
}

.name {
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  flex: 1;
}

.value {
  font-weight: 400;
  font-size: 15px;
  color: #151515;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: right;
}

.value i {
  font-size: 16px;
  color: #999999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 1;
}

.li div {
  display: inline-block;
}
.qx {
  color: rgb(102, 111, 131);
  font-weight: 500;
  float: left;
  margin-left: 20px;
  font-size: 18px;
}
.qd {
  color: #00c275;
  font-weight: 500;
  float: right;
  margin-right: 20px;
  font-size: 18px;
}
.gender {
  padding: 16px 20px;
  width: 100%;
  margin: 0px auto;
  font-size: 17px;
  border-bottom: 1px solid #e2e4ea;
}
.el-icon-success {
  font-size: 26px !important;
  color: #07c160 !important;
  float: right;
}
.round {
  width: 24px;
  height: 24px;
  border: 1px solid #000000;
  opacity: 0.3;
  border-radius: 100%;
  float: right;
}
.ts {
  color: red;
  font-size: 13px;
}
/* 保存按钮 */
.save-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #F7F7F7;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.save-button {
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
}

.save-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.save-text {
  position: relative;
  z-index: 2;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

.required {
  color: red;
  margin-right: 2px;
}
</style>




// WEBPACK FOOTER //
// src/views/information/index.vue